import { render, staticRenderFns } from "./UpdatePreview.vue?vue&type=template&id=137a5d7e&scoped=true&"
import script from "./UpdatePreview.vue?vue&type=script&lang=js&"
export * from "./UpdatePreview.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePreview.vue?vue&type=style&index=0&id=137a5d7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a5d7e",
  null
  
)

export default component.exports